var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.SeekBehaviours = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.touchBehaviour = _exports.focusBehaviour = _exports.clickBehaviour = _exports.activeIndexBehaviour = void 0;

  var focusBehaviour = function focusBehaviour(_ref) {
    var index = _ref.index,
        direction = _ref.direction,
        lastVisibleIndex = _ref.lastVisibleIndex;
    return {
      getNextIndex: function getNextIndex() {
        return direction === 'next' ? index : Math.max(0, index - 1);
      },
      shouldMove: function shouldMove() {
        return index >= lastVisibleIndex() - 1 && direction === 'next' || direction === 'prev';
      }
    };
  };

  _exports.focusBehaviour = focusBehaviour;
  focusBehaviour.mode = 'focusBehaviour';

  var clickBehaviour = function clickBehaviour(_ref2) {
    var index = _ref2.index,
        direction = _ref2.direction,
        lastVisibleIndex = _ref2.lastVisibleIndex;
    return {
      getNextIndex: function getNextIndex() {
        return direction === 'next' ? lastVisibleIndex() : Math.max(0, index - 2);
      },
      shouldMove: function shouldMove() {
        return true;
      }
    };
  };

  _exports.clickBehaviour = clickBehaviour;
  clickBehaviour.mode = 'clickBehaviour';

  var touchBehaviour = function touchBehaviour() {
    return {
      getNextIndex: function getNextIndex() {
        return 0;
      },
      shouldMove: function shouldMove() {
        return false;
      }
    };
  };

  _exports.touchBehaviour = touchBehaviour;
  touchBehaviour.mode = 'touchBehaviour';

  var activeIndexBehaviour = function activeIndexBehaviour(_ref3) {
    var index = _ref3.index;
    return {
      getNextIndex: function getNextIndex() {
        return index;
      },
      shouldMove: function shouldMove() {
        return true;
      }
    };
  };

  _exports.activeIndexBehaviour = activeIndexBehaviour;
  activeIndexBehaviour.mode = 'activeIndexBehaviour';
});